import { Text } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { EllipsisPlacement, OverflowEllipsisProps } from './types';

export const TextContainerStyled = styled(Text) <OverflowEllipsisProps>`

text-overflow: ellipsis;
white-space: nowrap;
overflow: hidden;
line-height: 1.5;
unicodeBidi: plaintext;
width: 235px;
${(props) =>
        css`
        direction: ${props.ellipsisPlacement === EllipsisPlacement.BEGINNING ? 'rtl' : 'ltr'};
`}';
            `;

